// Copyright (c) 2016 Deere & Company

import './warranty-modal.scss';
import React, {PropTypes} from 'react';
import {MediumModal} from 'deere-ui-modal-core';

const WarrantyMediumModal = props =>
    <MediumModal
        {...props}
        className='warranty-medium-modal'
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
    />;

WarrantyMediumModal.displayName = 'WarrantyMediumModal';
WarrantyMediumModal.propTypes = {
    isOpen: PropTypes.bool.isRequired
};

export default WarrantyMediumModal;



// WEBPACK FOOTER //
// ./src/shared/components/modal/medium-modal.js